'use client'
import { useEffect } from 'react'

export default function DocsRedirect() {
  useEffect(() => {
    window.location.href = '/docs'
  }, [])

  return (
    <section className="relative pt-32 pb-24 sm:pt-40 sm:pb-32 overflow-hidden min-h-screen flex items-center justify-center">
      <div className="absolute inset-0 bg-gradient-to-b from-[#4f46e5]/5 via-transparent to-transparent pointer-events-none" />
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[600px] bg-[#6366f1]/15 rounded-full blur-[160px] pointer-events-none opacity-50" />
      <p className="relative text-[#94a3b8]">Redirecting to docs...</p>
      <meta httpEquiv="refresh" content="0;url=/docs" />
    </section>
  )
}
